// 25/4/2025
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".side-filter-collection-menu ul li ul").forEach(function (subList) {
    if (subList.querySelector("li.active")) {
      subList.classList.add("show");
    }
  });
});

$(document).ready(function () {
  $(".carousel").slick({
    centerMode: true,
    centerPadding: "100px", // show half of next/prev item
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          centerPadding: "70px",
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          centerPadding: "70px",
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 2,
        },
      },
    ],
  });
});
// case carousel
$(".Essentialproducts-carousel").slick({
  arrows: true,
  dots: false,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
});
// case carousel
$(".case-carousel").slick({
  arrows: true,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
});

// testimonial
$(document).ready(function () {
  $(".testimonial-carousel").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 575,
        settings: { slidesToShow: 1 },
      },
    ],
  });
});

// best selling product
$(document).ready(function () {
  $(".product-carousel").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  });
});

//blog carousel
$(document).ready(function () {
  $(".blog-carousel").slick({
    centerMode: true,
    centerPadding: "150px", // show half of next/prev item
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          centerPadding: "50px", // show half of next/prev item
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: true,
          centerPadding: "50px", // show half of next/prev item
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// mouse hover image

const hoverImg = document.getElementById("hoverImg");
const links = document.querySelectorAll(".hover-link");

links.forEach((link) => {
  link.addEventListener("mouseenter", (e) => {
    const src = link.getAttribute("data-img");
    hoverImg.src = src;
    hoverImg.style.opacity = 1;
  });

  link.addEventListener("mousemove", (e) => {
    hoverImg.style.left = e.clientX + "px";
    hoverImg.style.top = e.clientY + "px";
  });

  link.addEventListener("mouseleave", () => {
    hoverImg.style.opacity = 0;
  });
});

document.addEventListener("scroll", () => {
  hoverImg.style.opacity = 0;
});


// query form//

document.querySelectorAll(".modal-trigger").forEach((button) => {
  button.addEventListener("click", () => {
    let modal = new bootstrap.Modal(
      document.querySelector(".common-query-modal")
    );
    modal.show();
  });
});

// var wow = new WOW({
//   boxClass: "wow",
//   animateClass: "animated",
//   offset: 0,
//   mobile: true, 
//   live: true, 
//   callback: function (box) {
//   },
//   scrollContainer: null, 
//   resetAnimation: true,
// });
// wow.init();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-button").forEach((btn) => {
    btn.addEventListener("click", function () {
      let accordion = this.closest(".accordion");
      let opened = accordion.querySelectorAll(".accordion-collapse.show");

      opened.forEach((openItem) => {
        if (
          openItem.id !== this.getAttribute("data-bs-target").replace("#", "")
        ) {
          new bootstrap.Collapse(openItem, { toggle: false }).hide();
        }
      });
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const featuredVideo = document.getElementById("featuredVideo");
//   const testimonialItems = document.querySelectorAll(".testimonial-item");

//   testimonialItems.forEach((item) => {
//     item.addEventListener("click", function () {
//       const videoSrc = this.getAttribute("data-video");

//       featuredVideo.querySelector("source").src = videoSrc;
//       featuredVideo.load();
//       featuredVideo.play();

//       const yOffset = -80;
//       const y =
//         featuredVideo.getBoundingClientRect().top + window.scrollY + yOffset;
//       window.scrollTo({ top: y, behavior: "smooth" });
//     });
//   });
// });

// video modal//
// document.addEventListener("DOMContentLoaded", function () {
//   const modal = document.getElementById("testimonialModal");
//   const video = document.getElementById("testimonialVideo");

//   modal.addEventListener("show.bs.modal", function (event) {
//     const button = event.relatedTarget;
//     const videoSrc = button.getAttribute("data-video");
//     video.querySelector("source").setAttribute("src", videoSrc);
//     video.load();
//   });

//   modal.addEventListener("hide.bs.modal", function () {
//     video.pause();
//     video.currentTime = 0;
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   let video = document.getElementById("testimonialVideo");
//   let modal = document.getElementById("exampleModal");

//   modal.addEventListener("hidden.bs.modal", function () {
//     video.pause();
//     video.currentTime = 0;
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-button").forEach((button) => {
    button.addEventListener("click", function () {
      let parent = document.querySelector("#accordionExample");
      let openItems = parent.querySelectorAll(".accordion-collapse.show");

      openItems.forEach((item) => {
        if (item.id !== this.getAttribute("data-bs-target").replace("#", "")) {
          new bootstrap.Collapse(item, { toggle: true });
        }
      });
    });
  });
});

jQuery(document).ready(function ($) {
  $(".common-query-modal").on("hidden.bs.modal", function () {
    // Reset the form fields
    $(this).find("form.wpcf7-form")[0].reset();

    // Remove validation error messages
    $(this).find(".wpcf7-response-output").hide();
    $(this).find(".wpcf7-not-valid-tip").remove();
    $(this).find(".wpcf7-form-control").removeClass("wpcf7-not-valid");
  });
});

// Enable hover on <details> in header menu (desktop only)
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 768) {
    const detailMenus = document.querySelectorAll('header-menu details');

    detailMenus.forEach(details => {
      const summary = details.querySelector('summary');

      if (summary) {
        // Open on mouseenter
        details.addEventListener('mouseenter', () => {
          details.setAttribute('open', true);
        });

        // Close on mouseleave
        details.addEventListener('mouseleave', () => {
          details.removeAttribute('open');
        });

        // Prevent default click toggle on desktop
        summary.addEventListener('click', (e) => {
          e.preventDefault();
        });
      }
    });
  }
});




